/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 *
 * @flow
 */

import Popup from './Popup';
import PopupContent from './PopupContent';

function getPopupConfig(type: 'success' | 'error' | 'notify' | 'spinner' | 'confirmation', onOk?: Function) {
  // console.info('getPopupConfig', type);
  if (type === 'error') {
    return {
      type: 'popup',
      heading: 'Oops',
      message: 'Something went wrong',
      buttons: [
        {
          text: 'OK',
          onClick: onOk,
        },
      ],
    };
  }
  if (type === 'success') {
    return {
      type: 'popup',
      heading: 'Request complete',
      message: 'Request completed successfully',
      buttons: [
        {
          text: 'OK',
          onClick: onOk,
        },
      ],
    };
  }
  if (type === 'notify') {
    return {
      type: 'notification',
      message: 'Server has been notified',
      buttons: [
        {
          text: 'OK',
          onClick: onOk,
        },
      ],
    };
  }
  if (type === 'confirmation') {
    return {
      type: 'confirmation',
      heading: 'Confirmation',
      message: 'Are you sure want to continue?',
      buttons: [
        {
          text: 'OK',
          onClick: onOk,
        },
      ],
    };
  }

  return {
    type: 'spinner',
    heading: 'Loading',
    message: 'This should only take a moment.',
  };
}

export { Popup, getPopupConfig, PopupContent };
